import { createContext, use } from "react";
import { ModalContextType } from "./types";

export const ModalContext = createContext<ModalContextType | null>(null);

export const useModalContext = () => {
  const context = use(ModalContext);

  if (!context) {
    throw new Error("useModalContext must be used within a Modal");
  }

  return context;
};
